export type ClassDictionary = Record<string, unknown>
export type ClassValue = string | boolean | null | undefined | ClassDictionary | Array<ClassValue>

export function clsx(...args: Array<ClassValue>): string {
    const classes: Array<string> = []

    for (const arg of args) {
        if (arg) {
            if (typeof arg === "string") {
                classes.push(arg)
            } else if (Array.isArray(arg)) {
                const inner = clsx(...arg)
                if (inner) {
                    classes.push(inner)
                }
            } else if (typeof arg === "object") {
                for (const [key, value] of Object.entries(arg)) {
                    if (value) {
                        classes.push(key)
                    }
                }
            }
        }
    }

    return classes.join(" ")
}
